import { useEffect, useState } from 'react';
import courseService from 'ApiService/Admin/courseService';

const SelectDepartment = ({ setDisable, selectedDepartment, setSelectedDepartment }) => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState([]);

  const fetchDepartments = async () => {
    try {
      const response = await courseService.getAllDepartments();
      if (response.data?.success) {
        const departmentsData = response.data.data || [];
        const sortedDepartments = [...departmentsData].sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        setDepartments(sortedDepartments);
      }
    } catch (error) {
      console.error('Error fetching departments:', error);
      setDepartments([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  useEffect(() => {
    const newErrors = [];
    if (!selectedDepartment?.trim()) {
      newErrors.push('Please select a department');
    }
    setErrors(newErrors || []);
    setDisable((newErrors || []).length > 0);
  }, [selectedDepartment, setDisable]);

  const handleDepartmentChange = (event) => {
    setSelectedDepartment(event.target.value);
  };

  return (
    <div className="w-full rounded-lg px-3 pt-7 md:px-8">
      <div className="flex justify-center">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">
          Select Department
        </h4>
      </div>

      <div className="mt-6 flex flex-col gap-6">
        <div className="mx-auto w-full md:w-1/2">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Department
          </label>
          <select
            onChange={handleDepartmentChange}
            value={selectedDepartment || ''}
            name="department"
            className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select Department</option>
            {loading ? (
              <option>Loading departments...</option>
            ) : (
              <>
                {departments?.map((dept, i) => (
                  <option key={dept._id} value={dept._id}>
                    {i + 1}. {dept.name}
                  </option>
                ))}
              </>
            )}
          </select>
        </div>
      </div>

      {(errors || []).length > 0 && (
        <div className="mt-4 text-center text-red-500">
          {errors?.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectDepartment;
